import React from 'react';
import DataManagementDictionariesTableRow from './DataManagementDictionariesTableRow';

const DataManagementDictionariesTableRows = ({
  category,
  code,
  columns,
  dictionaries,
}) => (
  dictionaries.map((dictionary, index) => (
    <DataManagementDictionariesTableRow
      key={`dataset_data_management_dictionary_table_row_${dictionary.code}`}
      category={category}
      code={code}
      dictionaryCode={dictionary.code}
      columns={columns}
      upward={index > 4}
    />
  ))
);

export default DataManagementDictionariesTableRows;
